import { IsBoolean, IsDateString, IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString, ValidateIf } from "class-validator";
import { Constants } from "@eagerdog/constants";

import { IAddOn } from "./add-on.interface";

export class AddOnDto implements Omit<IAddOn, "_id" | "club_id" | "event_id" | "purchased_quantity" | "created_at" | "updated_at" | "created_by" | "updated_by"> {
  //
  @IsEnum(Object.values(Constants.add_on_scope))
  @IsNotEmpty()
  scope: string;

  @IsNotEmpty()
  title: string;

  @IsNotEmpty()
  description: string;

  @IsNumber()
  fee: number;

  @IsOptional()
  @IsString()
  category?: string;

  @IsOptional()
  @IsString()
  image_url?: string;

  @IsOptional()
  @IsBoolean()
  is_active?: boolean;

  @IsOptional()
  @ValidateIf((o) => o.expires_at !== null)
  @IsDateString()
  expires_at?: string;

  @IsOptional()
  @IsNumber()
  available_quantity?: number;

  @IsOptional()
  @IsNumber()
  max_purchase_quantity?: number;
}
